import { getAuthHeaders, navigateToLogout } from '../fetch/auth';
import { ValidationResult } from '../fetch/validationResult';
import React, { Fragment } from 'react';
import DropzoneComponent from 'react-dropzone-component';
import { NotificationManager } from 'react-notifications';
import { Alert } from 'reactstrap';
import { isNullOrUndefined } from 'util';
import PropTypes from 'prop-types';
//import './DirectFileUpload.scss';

export class DirectFileUpload extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: []
    };

    this.djsConfig = {
      addRemoveLinks: true,
      acceptedFiles: '.xlsx, .xls, .csv',
    };

    this.dropzone = null;

    this.componentConfig = {
      iconFiletypes: ['.csv'],
      showFiletypeIcon: true,
      postUrl: props.endpointUrl,
    };

    this.handleFileChanges = () => this.setState({ errors: [] });

    this.success = (file) =>
      NotificationManager.success('Uploaded Succesfully', '', 3 * 1000);

    this.error = (file, json, xhr) => {
      if (json.Message) {
        this.setState({ errors: [json.Message] });
      } else {
        const errorsList = json.errors || json; // errors property is used when the server returns an error through the CreateErrorResponse extension method
        if (Array.isArray(errorsList)) {
          const errorMessages = Array.from(errorsList.map(e => e.errorMessage));
          this.setState({ errors: errorMessages });
        } else if (typeof errorsList === 'object') {
          let validationErrors = [];
          Object.keys(errorsList).forEach((key) => {
            validationErrors.push({ errorMessage: errorsList[key] });
          });

          const errorMessages = Array.from(validationErrors.map(e => e.errorMessage));
          this.setState({ errors: errorMessages });
        } else {
          this.setState({ errors: ['Unknown response received from the server, error details are below. For assistance with this error, please contact N9 Support.', json] });
        }
      }
    };

    this.dropzone = null;

    getAuthHeaders()
      .then((result) => {
        this.djsConfig.headers = result;
      })
      .catch((err) => this.setState({ errors: ["Authentication failed. Please refresh and try again."] }));
  }

  static propTypes = {
    endpointUrl: PropTypes.string.isRequired,
  };

  render() {
    const config = this.componentConfig;
    const djsConfig = this.djsConfig;

    const eventHandlers = {
      init: (dz) => (this.dropzone = dz),
      addedfile: this.handleFileChanges,
      removedfile: this.handleFileChanges,
      success: this.success,
      error: this.error,
    };

    return (
      <Fragment>
        <DropzoneComponent
          config={config}
          eventHandlers={eventHandlers}
          djsConfig={djsConfig}
        />
        {this.state.errors && this.state.errors.length > 0 && (
          <Alert color="danger" className="text-left mt-3">
            <h5 className="mb-0 text-dark">
              <ul>
                {this.state.errors.map((error, key) => <li className="mt-2" key={key}>{error}</li>)}
              </ul>
            </h5>
          </Alert>
        )}
      </Fragment>
    );
  }
}
